import React, { useState, useEffect } from "react";
import Toast from "react-bootstrap/Toast";

export default function ToastFun(props) {
  //const [isShow, setIsShow] = useState(false);
  //const [message, setMessage] = useState(props.message);

  return (
    <Toast
      show={props.isShow}
      onClose={props.onClose}
      delay={10000}
      autohide
      style={{
        position: "fixed",
        top: 10,
        right: 10,
        zIndex: 99999,
      }}
    >
      <Toast.Header>
        <strong className="mr-auto">Сообщение</strong>
        {/* <small>11 mins ago</small> */}
      </Toast.Header>
      <Toast.Body>
        <div
          class={"alert " + (props.alertType ? "alert-" + props.alertType : "")}
          role="alert"
        >
          {props.message}
        </div>
      </Toast.Body>
    </Toast>
  );
}
